import React from "react";
import { Link } from "react-router-dom";
import SiteLayout from "@/components/SiteLayout";
import Services from "@/sections/Services";
import Section from "@/theme/Section";
import Button from "@/theme/Button";
import { ArrowRight } from "lucide-react";

const ServicesPage = () => (
  <SiteLayout>
    <Services />
    <Section
      testid="services-cta-section"
      eyebrow="Next step"
      title='Got a brief? <span style="color:#c8ff2a">Send it over</span>.'
      subtitle="We respond in under 24 hours with a scoped estimate."
    >
      <Button as={Link} to="/contact">
        Start a project <ArrowRight size={14} strokeWidth={3} />
      </Button>
    </Section>
  </SiteLayout>
);

export default ServicesPage;
